/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { getData } from "../Services/getData";
import { UrlEnum, logout } from "../Utils/Utils";
import { updateData } from "../Services/updateData";
import { deleteData } from "../Services/deleteData";
import Modal from "../Components/Modal";
import { toast } from "react-toastify";
import { Vocabulary } from "../Utils/Vocabulary";
import { regexIBAN } from "../Utils/Constants";
import "react-toastify/dist/ReactToastify.css";

export default function AccountSettings() {
  const userId = localStorage.getItem("userId");
  const [user, setUser] = useState<any>(null);
  const [openModalDeleteAccount, setOpenModalDeleteAccount] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [newPassword, setNewPassword] = useState<{ password: string; confirmPassword: string }>({ password: "", confirmPassword: "" });
  /**
   *
   */
  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   */
  async function getUser() {
    try {
      const res = await getData(`${UrlEnum.users}/${userId}`);
      if (res && res.data) {
        setUser(res.data);
      }
    } catch (err: any) {
      toast.error(err);
    }
  }

  /**
   *
   * @param value
   * @param name
   */
  const validateField = (value: string, name: string) => {
    let errorMessage = "";

    if (name === "iban") {
      const regexIBANExp = new RegExp(regexIBAN);
      if (!regexIBANExp.test(value)) {
        errorMessage = Vocabulary.ibanMessageError;
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  /**
   *
   * @param field
   * @param value
   */
  const handleChange = (field: string, value: any) => {
    setUser((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleChangePassword = (field: string, value: any) => {
    setNewPassword((prev: any) => ({ ...prev, [field]: value }));
  };

  /**
   *
   * @param field
   * @param value
   */
  const handlePersonalDataChange = (field: string, value: any) => {
    setUser((prev: any) => ({
      ...prev,
      personalData: { ...prev.personalData, [field]: value },
    }));
  };

  /**
   *
   */
  const handleSave = async () => {
    await updateData(`${UrlEnum.users}/${userId}`, user)
      .then((res) => {
        if (!res) {
          toast.error("Eroare la salvarea datelor");
          return;
        }
        if (res && res.data) {
          setUser(res.data);
          toast.success("Datele au fost salvate cu succes");
        }
      })
      .catch(() => {
        toast.error("Eroare la salvarea datelor");
      });
  };

  const handleSavePassword = async () => {
    if (!newPassword.password || !newPassword.confirmPassword) {
      toast.error("Campurile nu pot fi goale");
      return;
    }
    if (newPassword.password !== newPassword.confirmPassword) {
      toast.error("Parolele nu sunt identice");
      return;
    }
    await updateData(`${UrlEnum.users}/${userId}`, { ...user, password: newPassword.password })
      .then((res) => {
        if (!res) {
          toast.error("Eroare la salvarea parolei");
          setNewPassword({ password: "", confirmPassword: "" });
          return;
        }

        toast.success("Parola schimbată cu succes");
        setNewPassword({ password: "", confirmPassword: "" });
      })
      .catch(() => {
        toast.error("Eroare la salvarea parolei");
        setNewPassword({ password: "", confirmPassword: "" });
      });
  };

  /**
   *
   */
  const handleDeleteAccount = async () => {
    await deleteData(`${UrlEnum.users}/${userId}`)
      .then((res) => {
        if (!res) {
          toast.error("Eroare la ștergerea contului");
          setOpenModalDeleteAccount(false);
          return;
        }
        if (res && res.data) {
          toast.success("Contul a fost șters cu succes");
          setOpenModalDeleteAccount(false);
          logout();
        }
      })
      .catch((err) => {
        toast.error("Eroare la ștergerea contului");
        setOpenModalDeleteAccount(false);
      });
  };

  if (!user) return null;

  return (
    <Box>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h5" mb={2}>
          {Vocabulary.accountSettings}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={Vocabulary.name}
              value={user.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={Vocabulary.email}
              value={user.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={Vocabulary.phone}
              value={user.personalData?.phoneNumber || ""}
              onChange={(e) =>
                handlePersonalDataChange("phoneNumber", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Typography color="text.secondary" mt={2}>
              {Vocabulary.IBANMessage}
            </Typography>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="iban"
              label={Vocabulary.iban}
              value={user.personalData?.iban || ""}
              onChange={(e) => {
                let newValue = e.target.value;
                newValue = e.target.value.toUpperCase().replace(/\s/g, "");
                handlePersonalDataChange("iban", newValue);
                validateField(e.target.value, e.target.name);
              }}
              error={!!errors["iban"]}
              helperText={errors["iban"]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={Vocabulary.accountFullName}
              value={user.personalData?.accountFullName || ""}
              onChange={(e) =>
                handlePersonalDataChange("accountFullName", e.target.value)
              }
            />
          </Grid>
        </Grid>
        <br/>
        <Button variant="contained" onClick={handleSave}>
            {Vocabulary.save}
          </Button>
          <br/><br/>
        <Divider />
        <br/>
        <Typography>{Vocabulary.resetPassword}</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              type="password"
              fullWidth
              label={Vocabulary.password}
              value={newPassword.password}
              onChange={(e) =>
                handleChangePassword("password", e.target.value)
              } />
          </Grid>
          <Grid item xs={12} sm={6}>

            <TextField
              type="password"
              fullWidth
              label={Vocabulary.confirmPassword}
              value={newPassword.confirmPassword}
              onChange={(e) =>
                handleChangePassword("confirmPassword", e.target.value)
              } />
          </Grid>
        </Grid>
        <br />
        <Button
        variant="contained"
        color="primary"
          onClick={handleSavePassword}
        >{Vocabulary.resetPassword}</Button>
        <br />
        <br />
        <Divider />
        <br />

        {/* Action Buttons */}
        <Box mt={3} display="flex" justifyContent="space-between">
          <Button
            color="error"
            onClick={() => setOpenModalDeleteAccount(true)}
          >
            {Vocabulary.deleteAccount}
          </Button>

        </Box>
      </Paper>

      {/* Confirmation Modal */}
      {openModalDeleteAccount ? (
        <Modal
          open={openModalDeleteAccount}
          onClose={() => setOpenModalDeleteAccount(false)}
          title={Vocabulary.deleteAccount}
        >
          <Typography variant="h6" mb={2} style={{ textAlign: "center" }}>
            {Vocabulary.deleteAccountText}
          </Typography>

          <Box display="flex" justifyContent="space-between">
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpenModalDeleteAccount(false)}
            >
              {Vocabulary.no}
            </Button>
            <Button variant="contained" onClick={handleDeleteAccount}>
              {Vocabulary.yes}
            </Button>
          </Box>
        </Modal>
      ) : null}
    </Box>
  );
}
